import React, { FC } from 'react';
import { LayoutProps } from '../DefaultTemplate/Layout';
import Footer from './Components/Footer/Footer';
import PreFooter from './Components/PreFooter/PreFooter';
import { FooterProps } from '../DefaultTemplate/Components/Footer/Footer';
import StickyHeader from '../../Common/StickyHeader/StickyHeader';

const Layout: FC<LayoutProps & FooterProps> = ({
  children,
  pageId,
  logoText,
  sectorsList,
  addresses,
  phoneNumber,
  euVatNumber,
  languages,
  email,
  officialId,
  socialLinks,
  template,
}) => {
  return (
    <>
      <StickyHeader pageId={pageId} logoText={logoText} template={template} />
      {children}
      <PreFooter />
      <Footer
        sectorsList={sectorsList}
        shortName={logoText}
        languages={languages}
        phoneNumber={phoneNumber}
        addresses={addresses}
        email={email}
        euVatNumber={euVatNumber}
        officialId={officialId}
        socialLinks={socialLinks}
      />
    </>
  );
};

export default Layout;
